import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e82fb97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = ["src", "onClick", "title"]

import SelectionImage from "../../assets/tool-selection.svg"
import LineImage from "../../assets/tool-line.svg"
import PointImage from "../../assets/tool-point.svg"
import HeightImage from "../../assets/tool-height.svg"
import CircleImage from "../../assets/tool-circle.svg"
import PolygonImage from "../../assets/tool-polygon.svg"
import MarkerImage from "../../assets/marker.svg"
import { Tools } from "@/classes/viewer/tools";
import { reactive } from "vue-demi";
import { useAppStateStore } from "@/store/app-state"


export default /*#__PURE__*/_defineComponent({
  __name: 'Toolbar',
  setup(__props) {

const data = reactive({
	tools: [{
		type: Tools.Selection,
		image: SelectionImage,
		tooltip: "Select elements"
	}, {
		type: Tools.Point,
		image: PointImage,
		tooltip: "Draw points"
	}, {
		type: Tools.Line,
		image: LineImage,
		tooltip: "Draw polyline"
	}, {
		type: Tools.Height,
		image: HeightImage,
		tooltip: "Draw height line"
	}, {
		type: Tools.Circle,
		image: CircleImage,
		tooltip: "Draw circle"
	}, {
		type: Tools.Polygon,
		image: PolygonImage,
		tooltip: "Draw polygon"
	}, {
		type: Tools.Annotation,
		image: MarkerImage,
		tooltip: "Add annotation"
	}],
});

const state = useAppStateStore();

function changeTool(tool: Tools) {
	state.setSelectedTool(tool);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).tools, (tool) => {
      return (_openBlock(), _createElementBlock("img", {
        key: tool.type,
        class: _normalizeClass(["toolbar-item", { selected: tool.type === _unref(state).selectedTool }]),
        src: tool.image,
        onClick: ($event: any) => {$event.preventDefault(); changeTool(tool.type)},
        title: tool.tooltip
      }, null, 10, _hoisted_2))
    }), 128)),
    _createElementVNode("button", {
      class: "toolbar-item tutorial-toolbar-button",
      type: "button",
      title: "Navigation tutorial",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openNavigationTutorial')))
    }, " ? ")
  ]))
}
}

})